var map = {
	"./placempus_jonas_bienz_website_still.jpg": 28,
	"./vlcsnap-2021-10-19-09h03m25s821.jpg": 29,
	"./vlcsnap-2021-10-19-09h04m32s685.jpg": 30,
	"./vlcsnap-2021-10-19-09h04m48s844.jpg": 31,
	"./vlcsnap-2021-10-19-09h05m21s879.jpg": 32,
	"./vlcsnap-2021-10-19-09h06m37s521.jpg": 33,
	"./vlcsnap-2021-10-19-09h07m16s840.jpg": 34,
	"./vlcsnap-2021-10-19-09h07m54s996.jpg": 35,
	"./vlcsnap-2021-10-19-09h08m18s332.jpg": 36
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51;